const normalizeProjectedStatKey = (statKey) => {
  if (typeof statKey !== "string") {
    return statKey;
  }

  return statKey
    .replace(/^goblin_/, "projected_")
    .replace(/^demon_/, "projected_")
    .replace(
      /^(projected_|promo_)?(?:three_pointers_made|three_points_made|threes_made|made_threes)$/,
      (_, prefix = "") => `${prefix}3ptm`
    )
    .replace(/plus\/minus$/, "plus_minus");
};

const lineValuesMatch = (left, right) => {
  if (left === null || left === undefined || right === null || right === undefined) {
    return false;
  }

  const leftValue = String(left).trim();
  const rightValue = String(right).trim();
  if (!leftValue || !rightValue) {
    return false;
  }

  if (!Number.isNaN(Number(leftValue)) && !Number.isNaN(Number(rightValue))) {
    return Math.abs(Number(leftValue) - Number(rightValue)) < 0.0001;
  }

  return leftValue === rightValue;
};

const getActiveVariantStatKey = (athlete) => {
  const statKey = normalizeProjectedStatKey(athlete?.stat_key);
  if (typeof statKey !== "string") {
    return statKey;
  }

  if (athlete?.hard) {
    return statKey.replace(/^projected_/, "demon_");
  }

  if (athlete?.easy) {
    return statKey.replace(/^projected_/, "goblin_");
  }

  return statKey;
};

export const isConfirmedUnavailableSelection = (item) => (
  item?.status === "removed" &&
  item?.classification === "market_confirmed_unavailable"
);

export const applyChangedSelectionLinesToBoard = (
  athletes,
  syncItems,
  getVariantKey,
  refreshToken = Date.now()
) => {
  if (!Array.isArray(athletes) || !Array.isArray(syncItems) || typeof getVariantKey !== "function") {
    return athletes;
  }

  const changedByKey = new Map(
    syncItems
      .filter((item) => (
        item?.status === "changed" &&
        item?.current_stat !== null &&
        item?.current_stat !== undefined &&
        String(item.current_stat).trim() !== ""
      ))
      .map((item) => [getVariantKey(item), item])
      .filter(([key]) => Boolean(key))
  );

  if (changedByKey.size === 0) {
    return athletes;
  }

  let changed = false;
  const reconciled = athletes.map((athlete) => {
    const syncItem = changedByKey.get(getVariantKey(athlete));
    if (!syncItem || lineValuesMatch(athlete?.stat, syncItem.current_stat)) {
      return athlete;
    }

    changed = true;
    const currentStat = String(syncItem.current_stat);
    const activeStatKey = getActiveVariantStatKey(athlete);
    const altStats = athlete?.alt_stats && typeof athlete.alt_stats === "object"
      ? { ...athlete.alt_stats, [activeStatKey]: currentStat }
      : athlete?.alt_stats;

    return {
      ...athlete,
      stat: currentStat,
      pp_stat: athlete?.pp_stat === false ? false : currentStat,
      alt_stats: altStats,
      stat_display: syncItem.current_stat_display || athlete?.stat_display || "",
      _boardRefreshState: "changed",
      _boardRefreshToken: refreshToken,
      _boardPreviousStat: athlete?.stat ?? null,
    };
  });

  return changed ? reconciled : athletes;
};
